import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value;
    if (!password) {
      return null; // if there's no value, don't validate
    }

    // Define regex for each requirement
    const hasMinLength = /.{8,}/.test(password);
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    const valid = hasMinLength && hasUpperCase && hasLowerCase && hasSpecialChar;
    return valid ? null : { passwordStrength: 'Password does not meet strength requirements' };
  };
}
export function phoneValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null; // no validation if empty
    }

    // Allow numbers with MIN 5 and MAX 15 digits
    const phoneNumberPattern = /^[0-9]{7,15}$/;

    return phoneNumberPattern.test(value)
      ? null
      : { invalidPhoneNumber: true };
  };
}
